import { ApiError } from "@odingard/sdk-client";
import type { StudioStateName } from "@odingard/design-system";

export type ReviewInteractionState = Extract<
  StudioStateName,
  | "error"
  | "unauthorized"
  | "unentitled"
  | "dependency_unavailable"
  | "concurrent_state_conflict"
  | "refused_for_separation_of_duties"
>;

function isDependencyUnavailable(error: unknown): boolean {
  return error instanceof TypeError ||
    (error instanceof ApiError && (error.status === 502 || error.status === 503 || error.status === 504 ||
      error.code === "dependency_unavailable"));
}

function isConflict(error: unknown): boolean {
  return error instanceof ApiError && (error.status === 409 || error.code === "conflict");
}

export function interactionStateFor(error: unknown): ReviewInteractionState {
  if (error instanceof ApiError && error.code === "entitlement_denied") return "unentitled";
  if (error instanceof ApiError && ["segregation_of_duties", "separation_of_duties"].includes(error.code)) return "refused_for_separation_of_duties";
  if (error instanceof ApiError && (error.status === 403 || error.code === "forbidden")) return "unauthorized";
  if (isConflict(error)) return "concurrent_state_conflict";
  if (isDependencyUnavailable(error)) return "dependency_unavailable";
  return "error";
}
